<template>
  <div class="console" id="terminal"></div>
</template>

<script>
import io from 'socket.io-client'
import axios from 'axios'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import 'xterm/css/xterm.css'

export default {
  props: {
    connected: Boolean,
    socketQuery: String
  },
  data () {
    return {
      error: null,
      term: new Terminal({
        pid: 1,
        name: 'terminal',
        cursorBlink: true,
        fontSize: '13',
        fontFamily: '"courier new", monospace'
      }),
      fitAddon: new FitAddon(),
      socket: io(axios.defaults.baseURL, {
        autoConnect: false,
        forceRenew: true
      })
    }
  },
  mounted () {
    this.term.loadAddon(this.fitAddon)
    this.term.open(document.getElementById('terminal', true))
    this.term.focus()
    // this.fitAddon.fit()
    // window.addEventListener('resize', this.resizeScreen, false)

    this.term.onData((data) => this.socket.emit('data', data))
    this.socket.on('data', (data) => this.term.write(data))

    this.socket.on('setTerminalOpts', (data) => {
      this.term.options.cursorBlink = data.cursorBlink
      this.term.options.scrollback = data.scrollback
      this.term.options.tabStopWidth = data.tabStopWidth
      this.term.options.bellStyle = data.bellStyle
    })

    this.socket.on('error', (err) => {
      this.error = err
      this.socket.disconnect()
    })

    this.socket.on('reauth', this.connect)
    this.socket.on('ready', () => this.$emit('update:connected', true))
    this.socket.on('disconnect', () => this.socket.io.reconnection(false))
    this.socket.on('disconnected', () => this.$emit('update:connected', false))

    this.connect()
  },
  methods: {
    connect () {
      this.error = null
      this.socket.io.opts.query = this.socketQuery + '&rows=' + this.term.rows + '&cols=' + this.term.cols
      this.socket.open()
    },
    resizeScreen () {
      if (this.term.cols && this.term.rows) {
        this.fitAddon.fit()
        this.$nextTick(() => this.socket.emit('resize', {
          cols: this.term.cols,
          rows: this.term.rows
        }))
      }
    }
  },
  watch: {
    socketQuery () {
      this.connect()
    }
  },
  beforeDestroy () {
    this.socket.disconnect()
  }
}
</script>

<style lang="scss">
.el-popup-parent--hidden {
  overflow: visible !important;
}
</style>
